/**
 * Sticky Header
 *
 * @package Wordpress\sww
 * @since 1.0.0
 * @version 1.0.1
 */

'use strict';

/* global jQuery */
/* global swwapp */
jQuery(function ($) {
  if ($('header.sww-campaign').length != 1) {
    swwapp.stickyHeader = {};

    /**
     * Method to return the scrollTop-value of the html element
     *
     * @since 1.0.0
     * @para string case-string to process, default is 'html'
     * @return int scrollHeight of the .sww-site-header element
     * @return int default the method returns the scrollTop of the html element
     */
    swwapp.stickyHeader.getScrollheight = function (element) {
      if (!element || element === '') {
        element = 'html';
      }
      switch (element) {
        case 'header':
          var tmpHeaderHeight = $('.sww-site-header');
          tmpHeaderHeight = tmpHeaderHeight[0].scrollHeight;
          return tmpHeaderHeight;
        case 'html':
          var tmpScrollHeight = $('html').scrollTop();
          return tmpScrollHeight;
      }
    };

    /**
     * Prperty to save the scrolLTop of the html element
     *
     * @since 1.0.0
     * @var int the scrollHeight of the html element
     */
    swwapp.stickyHeader.scrollTop = swwapp.stickyHeader.getScrollheight('html');

    /**
     * Prperty to save the scrollHeight of the sww-site-header element
     *
     * @since 1.0.0
     * @var int the scrollHeight of the element
     */
    swwapp.stickyHeader.headerHeight = swwapp.stickyHeader.getScrollheight('header');

    /**
     * Method to blend in or out the stickyHeader
     *
     * @since 1.0.0
     * @return void
     */
    swwapp.stickyHeader.blend = function () {
      if (swwapp.stickyHeader.scrollTop > swwapp.stickyHeader.headerHeight) {
        if (!$('section.sww-sticky-header').hasClass('shown')) {
          $('section.sww-sticky-header').addClass('shown');
          // $( 'div.sww-fixed-icons' ).addClass( 'shown' );

          $('section.sww-sticky-header').animate({
            'opacity': 1
          }, 500);
        }
      } else {
        if ($('section.sww-sticky-header').hasClass('shown')) {
          $('section.sww-sticky-header').animate({
            'opacity': 0
          }, 500);
          $('section.sww-sticky-header').removeClass('shown');
          // $( 'div.sww-fixed-icons' ).removeClass( 'shown' );
        }
      }

      //debugging code
      // console.group( 'Properties:' );
      // console.log( '<html> scrollTop: '+swwapp.stickyHeader.scrollTop );
      // console.log( '<.sww-site-header> scrollHeight: '+swwapp.stickyHeader.headerHeight );
      // console.groupEnd();

      return true;
    };

    /**
     * Method to watch the scrolling
     * Calls blend method to blend in or out the stickyHeader
     *
     * @since 1.0.0
     * @return void
     */
    swwapp.stickyHeader.watch = function () {
      $(window).on('scroll', function () {
        //actualizing the scrollHeight
        swwapp.stickyHeader.scrollTop = swwapp.stickyHeader.getScrollheight('html');

        //actualizing the HeaderHeight
        swwapp.stickyHeader.headerHeight = swwapp.stickyHeader.getScrollheight('header');

        //initiate blend in or out of the sticky Header
        swwapp.stickyHeader.blend();
      });
    }();
  }
});